<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div id="cronJobConfiguration">
      <mat-card-content style="padding-left: 40px;">
        <h4>{{'organization.create.section_4.set_time' | translate}}</h4>
        <div fxLayout="row wrap" fxLayoutGap="20px Grid" class="u-margin-top-15">
          <div fxFlex="100" fxFlex.gt-sm="35">
            <mat-form-field id="matFrmFieldSelectCronTime" class="mat-block">
              <input
                id="txtTime"
                matInput
                type="time"
                [required]="isRequired('multipleTimeFrequency')"
                formControlName="multipleTimeFrequency"
                placeholder="Time (UTC)"
              />
            </mat-form-field>
          </div>
        </div>

        <input
          *ngIf="(action !== 'view') && flag"
          id="txtError"
          matInput
          type="text"
          [required]="isRequired('error')"
          formControlName="error"
          placeholder='{{"organization.create.section_4.day_selection_error" | translate }}'
        />

        <div fxLayout="row wrap" fxLayoutGap="20px Grid" class="u-margin-top-15">
          <div fxFlex="100" fxFlex.gt-sm="30" fxLayoutAlign="start center">
            {{ "organization.create.section_4.all_week_days" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-10 u-margin-left-15">
            <mat-slide-toggle
              id="matSelectTogglecronalldays"
              formControlName="alldays"
              (change)="onAllDaysToggleChange($event)"
            >
            </mat-slide-toggle>
          </div>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="20px Grid" class="u-margin-top-15">
          <div fxFlex="100" fxFlex.gt-sm="30" fxLayoutAlign="start center">
            {{ "organization.create.section_4.weekdays.monday" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-10 u-margin-left-15">
            <mat-slide-toggle
              id="matSelectTogglecronMonday"
              formControlName="monday"
              (change)="onWeekdayToggleChange($event)"
            >
            </mat-slide-toggle>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="20px Grid" class="u-margin-top-15">
          <div fxFlex="100" fxFlex.gt-sm="30" fxLayoutAlign="start center">
            {{ "organization.create.section_4.weekdays.tuesday" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-10 u-margin-left-15">
            <mat-slide-toggle
              id="matSelectTogglecronTuesday"
              formControlName="tuesday"
              (change)="onWeekdayToggleChange( $event)"
            >
            </mat-slide-toggle>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="20px Grid" class="u-margin-top-15">
          <div fxFlex="100" fxFlex.gt-sm="30" fxLayoutAlign="start center">
            {{ "organization.create.section_4.weekdays.wednesday" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-10 u-margin-left-15">
            <mat-slide-toggle
              id="matSelectTogglecronWednesday"
              formControlName="wednesday"
              (change)="onWeekdayToggleChange( $event)"
            >
            </mat-slide-toggle>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="20px Grid" class="u-margin-top-15">
          <div fxFlex="100" fxFlex.gt-sm="30" fxLayoutAlign="start center">
            {{ "organization.create.section_4.weekdays.thursday" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-10 u-margin-left-15">
            <mat-slide-toggle
              id="matSelectTogglecronThursday"
              formControlName="thursday"
              (change)="onWeekdayToggleChange( $event)"
            >
            </mat-slide-toggle>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="20px Grid" class="u-margin-top-15">
          <div fxFlex="100" fxFlex.gt-sm="30" fxLayoutAlign="start center">
            {{ "organization.create.section_4.weekdays.friday" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-10 u-margin-left-15">
            <mat-slide-toggle
              id="matSelectTogglecronFriday"
              formControlName="friday"
              (change)="onWeekdayToggleChange( $event)"
            >
            </mat-slide-toggle>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="20px Grid" class="u-margin-top-15">
          <div fxFlex="100" fxFlex.gt-sm="30" fxLayoutAlign="start center">
            {{ "organization.create.section_4.weekdays.saturday" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-10 u-margin-left-15">
            <mat-slide-toggle
              id="matSelectTogglecronSaturday"
              formControlName="saturday"
              (change)="onWeekdayToggleChange($event)"
            >
            </mat-slide-toggle>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="20px Grid" class="u-margin-top-15">
          <div fxFlex="100" fxFlex.gt-sm="30" fxLayoutAlign="start center">
            {{ "organization.create.section_4.weekdays.sunday" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-10 u-margin-left-15">
            <mat-slide-toggle
              id="matSelectTogglecronSunday"
              formControlName="sunday"
              (change)="onWeekdayToggleChange( $event)"
            >
            </mat-slide-toggle>
          </div>
        </div>
      </mat-card-content>
    </div>
  </div>
</div>
